"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const react_uid_1 = require("react-uid");
const ListItem_1 = __importDefault(require("./ListItem"));
const Folder_1 = require("./Folder");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const globalVariables_1 = require("../../../common/globalVariables");
const TreeStructureWrapper = styled_components_1.default.div `
  width: 100%;
  background: #fff;
  padding: 16px;

  @media (min-width: 1024px) {
    padding: 16px;
  }

  .list-item {
    padding: 3px;
  }

  .box-wrapper {
    max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px;
    margin: 0 auto 0;
  }

  .tile-box {
    margin-bottom: 1.58vmin;
    box-shadow: 0px 0px 10px -1px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  .no-box-shadow {
    box-shadow: none;
  }

  .no-info-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 2.79vmin;
    letter-spacing: 0.5px;
    margin-top: 17.5vmin;

    img {
      margin-bottom: 3.5vmin;
      width: 130px;
    }
  }
`;
const TreeStructure = (_a) => {
    var props = __rest(_a, []);
    const onFolderClick = (folderData) => {
        const redirectLocation = folderData.deeplink
            ? new URL(folderData.deeplink).pathname
            : `/directory/folder/${folderData.title.toLowerCase().replace(/ /g, '-')}`;
        props.history.push({
            pathname: redirectLocation,
            search: props.location.search,
        });
    };
    const renderTreeStructure = () => {
        const tree = [];
        if (props.collection) {
            props.collection.map((node) => {
                const nodeType = Object.keys(node)[0];
                if (nodeType === 'pccaddiepage') {
                    return false;
                }
                if (node.folder) {
                    const folderIndentation = (react_1.default.createElement(Folder_1.Folder, { key: (0, react_uid_1.uid)(node.folder), onFolderClick: onFolderClick, folderData: node.folder }));
                    tree.push(folderIndentation);
                }
                else {
                    tree.push(react_1.default.createElement(ListItem_1.default, { content: node[nodeType], key: (0, react_uid_1.uid)(node[nodeType]) }));
                }
                return node;
            });
        }
        return tree;
    };
    return (react_1.default.createElement(TreeStructureWrapper, null,
        react_1.default.createElement(material_1.Box, { className: "box-wrapper" }, renderTreeStructure())));
};
const mapStoreToProps = store => ({
    navigations: store.getValue('navigations'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(TreeStructure));
